module.exports = __webpack_public_path__ + "img/奖牌.73afbce4.png";